import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom'
import {Container, Tooltip, ButtonToolbar, OverlayTrigger, Dropdown} from 'react-bootstrap'
import { css } from 'emotion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFile, faListAlt, faFolderOpen, faMapMarkedAlt, faArrowCircleLeft, faSync, faCalendar, faExclamationTriangle, faCog , faColumns, faLifeRing, faFileInvoiceDollar, faUniversity, faChartLine } from '@fortawesome/free-solid-svg-icons'
import { useWindowDimensions } from 'app/universal/utils/WindowDimensionsProvider'
import { hasAlphaAccess } from 'app/universal/route/withAlphaAccess'

import logo from 'app/universal/assets/images/logo-moulin.png'
import {
  revokeToken,
} from "state/common/actions";


const url = `${process.env.REACT_APP_API_URL}/e28XmZh3/`;
const typeformUrl = 'https://lemoulin.typeform.com/to/PworxMa6?embed=1';

const DesktopMenu = (props) => {
    const dispatch = useDispatch();
    const userRoles = useSelector((s) => (s.common && s.common.user && s.common.user.data && s.common.user.data.roles) || []);
    const canFinance = userRoles.includes("ROLE_FINANCE") || userRoles.includes("ROLE_DEV");
    const canStats = userRoles.includes("ROLE_STATS") || userRoles.includes("ROLE_DEV");
    const canPro = userRoles.includes("ROLE_ADMIN_PRO") || userRoles.includes("ROLE_DEV");
    // Onglets alpha : accès nominatif via admin_user.alpha_features (fiche
    // admin Sonata), quel que soit l'environnement.
    // ⚠️ garder les slugs synchrones avec index.js et AdminUser::ALPHA_FEATURES.
    const alphaFeatures = useSelector((s) => (s.common && s.common.user && s.common.user.data && s.common.user.data.alpha_features) || []);
    const canAlpha = (slug) => hasAlphaAccess(alphaFeatures, slug);
    const [typeformOpen, setTypeformOpen] = React.useState(false);
    const [helpTextIndex, setHelpTextIndex] = React.useState(0);
    const { width } = useWindowDimensions() || { width: 0 };
    const helpTexts = ['Un bug ?', 'Une demande ?'];

    React.useEffect(() => {
      const intervalId = window.setInterval(() => {
        setHelpTextIndex((prev) => (prev + 1) % helpTexts.length);
      }, 10000);

      return () => window.clearInterval(intervalId);
    }, []);

    const logout = () => {
        dispatch(revokeToken()).then(() => {
          window.localStorage.removeItem('token');
          window.localStorage.removeItem('refresh_token');
          window.location.href = '/';
        });
    };

    return (
      <React.Fragment>
        <Container fluid={true} className={css(style.header)}>
        <nav className={css(style.nav)}>
          <li className={css(style.menuLogo)}>
            <img src={logo} alt='Logo Moulin' />
          </li>
          <ul className={css(style.desktopMenu)}>
            {width >= 890 &&
              <span style={{ display: 'contents' }}>
                <li className={css(style.menuItem, style.doc)}>
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="tooltip-typeform-help">
                        Par ici pour faire une demande/retour concernant nos outils digitaux
                      </Tooltip>
                    }
                  >
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setTypeformOpen(true);
                      }}
                      aria-label="Un bug ? Une demande ? Ouvrir le formulaire"
                    >
                      {helpTexts[helpTextIndex]}
                    </a>
                  </OverlayTrigger>
                </li>
                <li className={css(style.menuItem)}><Link id="managerOrder" to={{
                    pathname: `/`,
                    search: window.location.search
                  }}><FontAwesomeIcon icon={faFolderOpen} /> Devis/Facture</Link></li>
                <li className={css(style.menuItem)}><Link id="missing-information" to={{
                    pathname: `/informations-devis-manquantes`,
                    search: window.location.search
                  }}><FontAwesomeIcon icon={faExclamationTriangle} /> Info manquante</Link></li>
                <li className={css(style.menuItem)}><Link id="planning" to={{
                    pathname: `/planning`,
                    search: window.location.search
                  }}><FontAwesomeIcon icon={faListAlt} /> Planning</Link></li>
                <li className={css(style.menuItem)}><Link id="roadmap" to={{
                    pathname: `/itineraires`,
                    search: window.location.search
                  }}><FontAwesomeIcon icon={faMapMarkedAlt} /> Tournée</Link></li>
                <li className={css(style.menuItem)}><Link id="calendar" to={{
                    pathname: `/agenda`
                  }}><FontAwesomeIcon icon={faCalendar} /> Agenda</Link></li>
                {/* Onglets B2B regroupés à droite après Agenda. Pipeline et
                    SAV B2B sont sortis de l'alpha le 29/10/2026 : ouverts aux
                    admins pro. Rapprochement et Dashboard data restent en
                    construction (Impayés reste visible partout). */}
                {canPro && (
                <li className={css(style.menuItem)}><Link id="pipeline-b2b" to={{
                    pathname: `/pipeline-b2b`,
                    search: window.location.search
                  }}><FontAwesomeIcon icon={faColumns} /> Pipeline</Link></li>
                )}
                {canPro && (
                <li className={css(style.menuItem)}><Link id="pipeline-sav" to={{
                    pathname: `/pipeline-sav`,
                    search: window.location.search
                  }}><FontAwesomeIcon icon={faLifeRing} /> SAV B2B</Link></li>
                )}
                <li className={css(style.menuItem)}><Link id="recouvrement-impayes" to={{
                    pathname: `/recouvrement-impayes`,
                    search: window.location.search
                  }}><FontAwesomeIcon icon={faFileInvoiceDollar} /> Impayés</Link></li>
                {canAlpha('rapprochement_bancaire') && canFinance && (
                <li className={css(style.menuItem)}><Link id="rapprochement-bancaire" to={{
                    pathname: `/rapprochement-bancaire`,
                    search: window.location.search
                  }}><FontAwesomeIcon icon={faUniversity} /> Rapprochement</Link></li>
                )}
                {canAlpha('dashboard_data') && canStats && (
                <li className={css(style.menuItem)}><Link id="dashboard-data" to={{
                    pathname: `/dashboard-data`,
                    search: window.location.search
                  }}><FontAwesomeIcon icon={faChartLine} /> Dashboard data</Link></li>
                )}
              </span>
            }

          </ul>
          {/* ⚙️ hors du <ul> scrollable : toujours visible à droite, et son
              sous-menu n'est pas rogné par l'overflow de la barre */}
          {width >= 890 &&
            <div className={css(style.menuRight)}>
              <Dropdown className={css(style.button)} drop="left">
                  <Dropdown.Toggle variant="outline-light" className="mt-1">
                      <FontAwesomeIcon icon={faCog} />
                  </Dropdown.Toggle>
                  <Dropdown.Menu variant="dark">
                      <Dropdown.Item as={Link} to={'/appel_offre'}>
                          Prix Appel d'offre
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to={'/lmvp-plateaux'}>Aperçu LMVP plateaux-repas</Dropdown.Item>
                      <Dropdown.Item as={Link} to={'/companion'}>Companion livreur</Dropdown.Item>
                      <Dropdown.Item as={Link} to={'/itineraires-b2c'}>Itinéraires B2C</Dropdown.Item>
                      {canAlpha('rotation_carte') && <Dropdown.Item as={Link} to={'/rotations-forfaits'}>Rotation de la carte</Dropdown.Item>}
                      <Dropdown.Item href="#/" onClick={ () => window.location.reload()}>Rafraîchir les données</Dropdown.Item>
                      <Dropdown.Item href={url}>Retour au BO</Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item href="#/" onClick={ () => logout()}>Se déconnecter</Dropdown.Item>
                  </Dropdown.Menu>
              </Dropdown>
            </div>
          }
        </nav>
      </Container>

        {typeformOpen && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 20000,
            background: 'rgba(0, 0, 0, 0.65)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 16
          }}
          onClick={() => setTypeformOpen(false)}
          role="dialog"
          aria-modal="true"
          aria-label="Typeform"
        >
          <div
            style={{
              width: 'min(980px, 100%)',
              background: '#fff',
              borderRadius: 8,
              overflow: 'hidden',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
              display: 'flex',
              flexDirection: 'column',
              maxHeight: '90vh'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                padding: '12px 16px',
                background: '#f5f5f5',
                borderBottom: '1px solid #e5e5e5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <div style={{ fontSize: 14, fontWeight: 700, color: '#111827' }}>
                Demande au pôle Système d'Information (SI)
              </div>
              <button
                type="button"
                onClick={() => setTypeformOpen(false)}
                style={{
                  background: 'transparent',
                  border: 0,
                  fontSize: 22,
                  lineHeight: 1,
                  cursor: 'pointer',
                  padding: '2px 6px',
                  color: '#111827'
                }}
                aria-label="Fermer"
              >
                &times;
              </button>
            </div>

            <div style={{ padding: 0, flex: 1 }}>
              <div
                style={{
                  padding: '10px 12px',
                  background: '#111',
                  borderBottom: '1px solid #333',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 10
                }}
              >
                <span style={{ fontSize: 12, color: '#f5f5f5', textAlign: 'left' }}>
                  Avant toute demande merci de regarder que l'information n'existe pas dans la documentation
                </span>
                <a
                  href="https://moulindev.freshdesk.com/support/solutions"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-block',
                    background: '#e6005c',
                    color: '#fff',
                    textDecoration: 'none',
                    fontWeight: 700,
                    fontSize: 12,
                    borderRadius: 6,
                    padding: '8px 12px',
                    whiteSpace: 'nowrap'
                  }}
                >
                  Documentation
                </a>
              </div>
              <iframe
                src={typeformUrl}
                title="Typeform"
                style={{ width: '100%', height: '80vh', border: 0, display: 'block' }}
              />
            </div>
          </div>
        </div>
      )}
      </React.Fragment>
    )
}

const style = {
  header: {
    background: "#689D71",
  },
  // La barre ne passe plus à la ligne : défilement horizontal, ⚙️ sticky à droite
  nav: {
    display: 'flex',
    alignItems: 'stretch',
  },
  'desktopMenu': {
    listStyleType: 'none',
    margin: '0',
    padding: '0',
    height: '52px',
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'stretch',
    flex: '1 1 auto',
    minWidth: 0,
    overflowX: 'auto',
    overflowY: 'hidden',
    '::-webkit-scrollbar': {
      height: '4px',
    },
    '::-webkit-scrollbar-thumb': {
      background: 'rgba(255, 255, 255, 0.4)',
      borderRadius: '2px',
    },
  },
  menuLogo:{
    float: 'left',
    flexShrink: 0,
    display: 'block',
    textAlign: 'center',
    padding: '3px 16px 0px 0',
    textDecoration: 'none',
    transition: '300ms',
    cursor: 'pointer',
    ':hover': {
      opacity: '0.5'
    }
  },
  menuItem: {
    flexShrink: 0,
    borderLeft: '1px solid rgba(255, 255, 255, 0.2)',
    a: {
      display: 'block',
      color: 'white',
      textAlign: 'center',
      padding: '14px 16px',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
      ':hover': {
        opacity: '0.5'
      }
    }
  },
  doc: {
    'backgroundColor': '#e6005c',
    a: {
      width: '150px',
      minWidth: '150px',
      height: '52px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      whiteSpace: 'nowrap',
      padding: 0
    }
  },
  'active': {
    'color' : 'black'
  },
  'menuRight':{
    border: 'none',
    // Hors de la barre scrollable : toujours visible à droite
    marginLeft: 'auto',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '8px',
  },
  'button': {
    color: 'black'
  },
}

export default DesktopMenu
